import { HttpAxiosRequest } from '../httpAxiosBase'
import {SistemaPrincipal} from "../../types/workflow/cache";
import {Sistema} from "../../pages/messages/types";
import { EntityWithIdAndDescription } from "../../types"

export type SistemaSelectoresDTO = {
    paises: SistemaPrincipal[]
    tipos: EntityWithIdAndDescription<number>[]
    sistemas: Sistema[]
}

export const HttpSystems = {
    getEndpoint: (url = '') => `workflow/sistemas${url}`,

    getSystemTypesByUser: () : Promise<Sistema[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint('/tipos')),

    getSystemPrincipalsByUser: () : Promise<SistemaPrincipal[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint('/principales')),

    getSystemPrincipalsWithCreationPermission: (): Promise<SistemaPrincipal[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint('/principales-permiso-creacion')),

    getByPrincipalForUser: (codSistemaPrincipal: number): Promise<Sistema[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint(`/por-principal?codSistemaPrincipal=${codSistemaPrincipal}`)),

    getByCountries: (codsPais: string): Promise<{ id: number; descripcion: string }[]> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint(`/por-pais?codsPais=${codsPais}`)),

    getSelectores: (permisosUsuario = false): Promise<SistemaSelectoresDTO> =>
        HttpAxiosRequest.get(HttpSystems.getEndpoint(`/selectores?permisosUsuario=${permisosUsuario}`))

}
